module.exports = __webpack_public_path__ + "001dfa58dd1f6c2731b025136a4cb004.pdf";